export default "__VITE_ASSET__CLkjoJgY__"